/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  CssBaseline,
  Snackbar,
  ThemeProvider,
  Typography,
} from '@mui/joy';
import { KeyboardArrowRight } from '@mui/icons-material';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import PricingPlanForm from './widgets/PricingPlanForm';
import { theme } from '../../main/theme/constants';

export default function PricingPlanDetailScreen() {
  const { id } = useParams();
  const { t } = useTranslation('ui');
  const navigate = useNavigate();
  const location = useLocation();

  const [showCreatedSnack, setShowCreatedSnack] = useState(false);

  useEffect(() => {
    if (location.state?.pricingPlanJustCreated) {
      setShowCreatedSnack(true);
      navigate(
        { pathname: location.pathname, search: location.search, hash: location.hash },
        { replace: true, state: {} }
      );
    }
  }, [location.state, location.pathname, location.search, location.hash, navigate]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box m={3}>
        <Breadcrumbs separator={<KeyboardArrowRight />} aria-label="breadcrumbs">
          <Link color="neutral" href="/PricingPlans">
            {t('nav.pricingPlans')}
          </Link>
          <Typography>{t('pricingPlans.breadcrumbDetail')}</Typography>
        </Breadcrumbs>
        <Typography level="h1" textAlign="start" sx={{ mb: 2 }}>
          {t('pricingPlans.detailTitle')}
        </Typography>

        <PricingPlanForm mode="edit" planId={id} hideBreadcrumbs embed />
      </Box>

      <Snackbar
        open={showCreatedSnack}
        autoHideDuration={3500}
        onClose={() => setShowCreatedSnack(false)}
        color="success"
        variant="soft"
      >
        {t('pricingPlans.snackbarCreated')}
      </Snackbar>
    </ThemeProvider>
  );
}
